import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/compliance-audit-templates/')({
    beforeLoad: (): void => {
        throw redirect({ to: '/admin-console/platform-content/compliance-audit-templates/search', replace: true });
    },
});
